import React from "react";
import TextBox from "carbon-react/lib/__experimental__/components/textbox";
import SearchButton from "../common/SearchButton";
import UtcDateRange from "../common/UtcDateRange";
import {
  Select,
  Option,
} from "carbon-react/lib/__experimental__/components/select";
import { Row, Column } from "carbon-react/lib/components/row";
import {
  auditOperations,
  auditLogEntryFieldNames,
} from "../../constants/model";

import "./AuditLogFilter.css";

const searchByKeys = Object.freeze({
  all: "all",
  agentEmail: auditLogEntryFieldNames.agentEmail,
  agentId: auditLogEntryFieldNames.agentId,
  operation: auditLogEntryFieldNames.operation,
  subjectEmail: auditLogEntryFieldNames.subjectEmail,
  subjectId: auditLogEntryFieldNames.subjectId,
});

const filterByOptionMetadata = [
  {
    text: "Show All",
    value: searchByKeys.all,
    key: searchByKeys.all,
  },
  {
    text: "Acting Agent Id",
    value: searchByKeys.agentId,
    key: searchByKeys.agentId,
  },
  {
    text: "Acting Agent Email",
    value: searchByKeys.agentEmail,
    key: searchByKeys.agentEmail,
  },
  {
    text: "Subject Id",
    value: searchByKeys.subjectId,
    key: searchByKeys.subjectId,
  },
  {
    text: "Subject Email",
    value: searchByKeys.subjectEmail,
    key: searchByKeys.subjectEmail,
  },
  {
    text: "Operation",
    value: searchByKeys.operation,
    key: searchByKeys.operation,
  },
];

const AuditLogFilter = ({
  searchValue,
  onSearchValueUpdate,
  searchBy,
  onSearchByUpdate,
  searchDateFromUtc,
  searchDateToUtc,
  onSearchDateRangeUpdate,
  onSearch,
}) => {
  const onSearchTermKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      onSearch();
    }
  };

  const onSearchByChanged = (newSearchBy) => {
    const prevSearchBy = searchBy;
    onSearchByUpdate(newSearchBy);

    switch (newSearchBy) {
      case searchByKeys.all:
        onSearchValueUpdate("");
        forceSearchBypassingState(newSearchBy, "");
        return;
      case searchByKeys.operation:
        onSearchValueUpdate(auditOperations[0].value);
        forceSearchBypassingState(newSearchBy, auditOperations[0].value);
        return;
      default:
        break;
    }

    if (prevSearchBy === searchByKeys.operation) onSearchValueUpdate("");
  };

  const onOperationSearchValueChanged = (operation) => {
    onSearchValueUpdate(operation);
    forceSearchBypassingState(searchBy, operation);
  };

  const forceSearchBypassingState = (forceSearchBy, forceSearchValue) => {
    //  Necessary to ensure search performed with latest state - React state sync issue
    onSearch(forceSearchBy, forceSearchValue);
  };

  const searchValueInputControl = (
    <>
      {searchBy && searchBy === searchByKeys.operation ? (
        <Select
          id="audit-log-filter-search-by-operation"
          preventFocusAutoOpen={true}
          filterable={false}
          placeholder={"Select operation..."}
          value={searchValue}
          onChange={(e) => {
            onOperationSearchValueChanged(e.target.value[0].optionValue);
          }}
        >
          {auditOperations.map((operation) => {
            return (
              <Option
                id={`audit-log-filter-search-by-operation-${operation.value}`}
                key={operation.value}
                text={operation.displayName}
                value={operation.value}
              />
            );
          })}
        </Select>
      ) : searchBy && searchBy === searchByKeys.all ? (
        <TextBox
          id="audit-log-filter-search-All"
          disabled
          value={searchValue}
        />
      ) : (
        <TextBox
          id="audit-log-filter-search-term"
          placeholder="Search term (leave blank to show All)..."
          value={searchValue}
          onChange={(e) => onSearchValueUpdate(e.target.value)}
          onKeyDown={onSearchTermKeyDown}
        />
      )}
    </>
  );
  return (
    <form
      className="audit-log-filter"
      onSubmit={(e) => {
        e.preventDefault();
        onSearch();
      }}
    >
      <Row className="audit-log-filter-row" columns="7">
        <Column className="audit-log-filter-column" columnSpan="4">
          <Row columns="7" gutter="medium">
            <Column
              className="audit-log-filter-column"
              columnAlign="left"
              columnSpan="2"
            >
              <Select
                id="audit-log-filter-search-by"
                autoFocus
                preventFocusAutoOpen={true}
                filterable={false}
                placeholder={"Search by..."}
                value={searchBy}
                onChange={(e) => {
                  onSearchByChanged(e.target.value[0].optionValue);
                }}
              >
                {filterByOptionMetadata.map((filterOption) => {
                  return (
                    <Option
                      id={`audit-log-filter-search-by-${filterOption.value}`}
                      key={filterOption.key}
                      text={filterOption.text}
                      value={filterOption.value}
                    />
                  );
                })}
              </Select>
            </Column>
            <Column
              className="audit-log-filter-column"
              columnAlign="left"
              columnSpan="3"
            >
              {searchValueInputControl}
            </Column>
            <Column
              className="audit-log-filter-column"
              columnAlign="left"
              columnSpan="2"
            >
              <SearchButton id="auditLogFilter_searchBtn" type="submit" />
            </Column>
          </Row>
        </Column>
        <Column
          className="audit-log-filter-column"
          columnAlign="right"
          columnSpan="3"
        >
          <UtcDateRange
            idPrefix="auditLogFilter_dateRange"
            fromDateUtc={searchDateFromUtc}
            toDateUtc={searchDateToUtc}
            onChange={onSearchDateRangeUpdate}
            fromLabel="From"
            toLabel="To"
            inlineLabels={true}
          />
        </Column>
      </Row>
    </form>
  );
};

export default AuditLogFilter;
export { searchByKeys };
